import { render, staticRenderFns } from "./control-favorites.vue?vue&type=template&id=497e5aa4&"
import script from "./control-favorites.vue?vue&type=script&lang=js&"
export * from "./control-favorites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('497e5aa4')) {
      api.createRecord('497e5aa4', component.options)
    } else {
      api.reload('497e5aa4', component.options)
    }
    module.hot.accept("./control-favorites.vue?vue&type=template&id=497e5aa4&", function () {
      api.rerender('497e5aa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/header/control-favorites.vue"
export default component.exports